var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2 mb-4 text-gray-dark text-xs border-gray"},[_c('div',[_c('rich-text-renderer',{attrs:{"document":_vm.rightOfWithdrawal}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }